import { render, staticRenderFns } from "./Associati.vue?vue&type=template&id=da9ee9b4&"
import script from "./Associati.vue?vue&type=script&lang=js&"
export * from "./Associati.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports